const usd = new Intl.NumberFormat("en-US", { style: "currency", currency: "USD", maximumFractionDigits: 0 });
const usdCents = new Intl.NumberFormat("en-US", { style: "currency", currency: "USD", minimumFractionDigits: 2 });

export function fmtPrice(n) {
  const v = Number(n) || 0;
  return Number.isInteger(v) ? usd.format(v) : usdCents.format(v);
}

export const MIN_REVIEWS_FOR_RATING = 3;
